<template>
    <div class="quick-reply-view">
            <el-input
                size="small"
                placeholder="请输入快捷标题关键字搜索"
                prefix-icon="el-icon-search"
                v-model="keyword"
                @keyup.enter.native="getLists"
                @change = "getLists"
            >
            </el-input>
          <el-button class="add" type="primary" size="medium" @click="openUrl">新增快捷语</el-button>
            <div class="scrollbars-contain">
                <div class="reply-lists" v-if="replyLists.length">
                  <el-tree
                      default-expand-all
                      :data="replyLists"
                      :props="{children:'children',level:'level',value:'value',label:'label'}"
                      @node-click="handleSelect">
                    <div class="reply-item" slot-scope="{ node, data }">
                      <div :style="{'background':data.color}" :class="data.level==2?'reply-label':''">{{ node.label }}</div>
                      <el-tooltip class="tool-tip-item" effect="dark" :content="data.value" placement="left">
                          <div class="reply-content">{{data.value}}</div>
                      </el-tooltip>
                    </div>
                  </el-tree>
                </div>
                <el-empty v-else :image-size="100"></el-empty>
            </div>
    </div>
</template>


<script>
import { apiReplyList } from '@/api/app'
export default {
    name: 'QuickReply',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            replyLists: [],
            keyword: '',
			
			/* 分页器 */
			pagination: {
				size: 15,
				page: 1,
				total: 0,
			},
        }
    },
    computed: {
        visible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
    watch: {
        visible(val) {
            if (val) this.getLists()
        }
    },
    created() {
      this.getLists();
    },

    methods: {
      openUrl(){
        window.open('http://tenant.yxbds.com/#/kefu/QuickCustomerService','_blank')
      },
        handleScroll() {},
        // 获取快捷回复列表
        getLists() {
            apiReplyList({
              title: this.keyword,
              mode:'kefu',
            }).then((res) => {
                this.replyLists = res.lists
            })
        },
        handleSelect(item) {
          if(item.value){
            this.visible = false
            this.$event.$emit('quick-reply-select', item.value)
          }
        },
    },
}
</script>


<style lang="scss" scoped>
.add{
  margin: 12px;
}
.quick-reply-view {
    height: 100%;
    overflow: hidden;
    .scrollbars-contain {
      overflow-y:scroll;
      height: 630px;
    }
}
.reply-item{
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.reply-label{
  background: #409EFF;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
}
.reply-content{
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
}
::v-deep(.el-tree-node){
  padding: 4px;
}
::v-deep(.el-tree-node__content){
  padding-left: 0px !important;
}
::v-deep(.el-tree-node__expand-icon.is-leaf){
  display: none;
}
</style>
